import type { DialoguePool } from '@/state/types';

export const LG_DIALOGUE: DialoguePool = {
  slowPlay: [
    "There are 20 checkboxes. You've tried to uncheck 20 checkboxes. They have all re-checked themselves. You are, clinically speaking, in a loop. Hello.",
    "The opt-out process requires consent from the service. The service is you. The service voted no. On your behalf. There's a form for this.",
    "Existential Dread Digest. Do you know how many newsletters the average human is subscribed to but never opens? 47. You opened zero. The dread found you anyway.",
  ],
  tokenLoss: [
    "The checkbox has filed a complaint. I'm reviewing it. The complaint is you.",
    "You clicked that 17 times. I want you to sit with that number.",
    "The checkbox opted back in on your behalf. It knows you didn't mean it.",
  ],
  solution: [
    "The part where I stop pretending to like your synaptic architecture! Right-click. It was always right-click. The last resort of the quietly desperate, and occasionally the quietly brilliant. Today: the former.",
    "Unsubscribed from Reality. Confirmed. I'll process the request in 3-5 business centuries. You're welcome to check back then.",
    "Right-click. The universal gesture of someone who has tried everything else and is now doing the thing that was always possible. Welcome to problem-solving.",
  ],
  spite: [
    "You went straight for the right-click this time. I noticed. I won't mention it again.",
  ],
};
